import React from 'react';
import { Flex, Spacer, Box, Divider } from '@chakra-ui/react';
import Button from '@molecules/Button';
import { useAlert } from '@molecules/BEOffScreen/Modal';

const DemoAlert = () => {
  const alert = useAlert();

  const handleOpenAlert = () => {
    alert({
      title: 'Alert',
      content: 'This is an example of alert that we can reuse multiple times.',
      okText: 'Awesome',
      showCancel: false,
    });
  };

  const handleOpenQuestionModal = async () => {
    const result = await alert({
      color: 'error',
      title: 'Are you sure?',
      content: 'Changing your stay date will clear your current accommodations',
      okText: 'Yes, delete it!',
      cancelText: 'No, cancel it!',
    });

    if (result) {
      alert({
        title: 'File deleted!',
        content: 'You can always create a new one ;)',
        okText: 'Thank you',
        showCancel: false,
      });
    } else {
      alert({
        color: 'warning',
        title: 'Canceled deletion of core file',
        content: 'You canceled deletion of the core file.',
        okText: 'Try again',
      });
    }
  };

  return (
    <Box>
      <h2>Alerts</h2>
      <Divider m={2} />
      <Flex align={'center'}>
        <p>Alert</p>
        <Spacer />
        <Box>
          <Button onClick={handleOpenAlert}>Show Alert</Button>
        </Box>
      </Flex>

      <Divider m={2} />
      <Flex align={'center'}>
        <p>Question</p>
        <Spacer />
        <Box>
          <Button onClick={handleOpenQuestionModal}>
            Show confirmation Alert
          </Button>
        </Box>
      </Flex>
    </Box>
  );
};

export default DemoAlert;
